// extracted by mini-css-extract-plugin
export default {"playerWrapper":"PodcastPlayer_playerWrapper__+FInF"};